import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { AxiosError } from 'axios'
import {
  fetchSystemSettings,
  updateSystemSetting,
  type SystemSettingRead,
  type SystemSettingsList,
} from '@/api/adminSystemSettings'
import { queryKeys } from '@/lib/queryKeys'
import { toast } from '@/stores/useToastStore'
import { getErrorMessage } from '@/utils/getErrorMessage'

export function useSystemSettings() {
  return useQuery<SystemSettingsList>({
    queryKey: queryKeys.adminSystemSettings.all,
    queryFn: fetchSystemSettings,
  })
}

export function useUpdateSystemSetting() {
  const queryClient = useQueryClient()

  return useMutation<
    SystemSettingRead,
    AxiosError,
    { key: string; value: string }
  >({
    mutationFn: ({ key, value }) => updateSystemSetting(key, value),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.adminSystemSettings.all,
      })
      toast.success('System setting updated')
    },
    onError: error => {
      toast.error(getErrorMessage(error, 'Failed to update system setting'))
    },
  })
}
